a.shared.tabbox = (function(){
	return {
		init:function(){
			$('div.itabbox').each(function(){
				a.shared.tabbox.initTabBox(this,false);
			});
		},
		initTabBox:function(box,loadtab){
			var loadindex = 0;
			var tabs = $('>ul.itabs>li',box);
			var boxes = $('>.itabcontent>div',box);
			// Reset
			$(tabs).removeClass('active');
			$(boxes).hide();
			if ((typeof(loadtab) == 'number') && boxes.length >= loadtab) {
				loadindex = loadtab;
			}
			if (tabs.length != 0 && tabs.length == boxes.length) {
				$(tabs[loadindex]).addClass('active');
				$(boxes[loadindex]).show();
				$(tabs).unbind('click').click(function(){
					$('>ul.itabs>li.active',box).removeClass('active');
					$(this).addClass('active');
					$(boxes).hide();
					$(boxes[$(this).index()]).show();
				});
			}
			else {
				return false;
			}
		},
		changeTab:function(box,loadtab){
			var loadindex = 0;
			var tabs = $('>ul.itabs>li',box);
			var boxes = $('>.itabcontent>div',box);
			$(tabs).removeClass('active');
			$(boxes).hide();
			if ((typeof(loadtab) == 'number') && boxes.length >= loadtab) {
				loadindex = loadtab;
			}
			else if ((typeof(loadtab) == 'string')) {
				tabs.each(function(i,e){
					if ($(e).attr('data-tab-id')==loadtab) {
						loadindex = i;
					}
				});
			}
			if (tabs.length != 0 && tabs.length == boxes.length) {
				$(tabs[loadindex]).addClass('active');
				$(boxes[loadindex]).show();
			}
			else {
				return false;
			}
		}
	}
}());